import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    path: '/aulas',
    name: 'aulas',
    component: () => import(/* webpackChunkName: "aulas" */ '../views/AulasView.vue')
  },
  {
    path: '/form_aula',
    name: 'form_aula',
    component: () => import(/* webpackChunkName: "form_aula" */ '../views/FormAulasView.vue'),
    children: [{
      path: ':id_aula', name: 'editar_aula', component: () => import(/* webpackChunkName: "aulas" */ '../views/AulasView.vue'),
    }]
  },
  {
    path:'/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "form_aula" */ '../views/LoginView.vue')
  }
  // ,{
  //   path:'/register',
  //   name: 'register',
  //   component: () => import(/* webpackChunkName: "form_aula" */ '../views/LoginView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if(to.name !== 'login' && to.name !== 'register' && !localStorage.getItem('authUser')){
    next('/login');
  }else {
    if(to.name === 'form_aula'){
      permitir()
    }
    next();
  }
})

 function permitir(){
    const user = JSON.parse(localStorage.getItem('authUser'))
    const token_user = user.token;
    const reqUser =  fetch('https://ensino.sbcp.org.br/API_auth.php?action=user&token='+token_user)
    .then(response => response.json())
    .then(function(data) {
      if((user.idUsuario === data.idUsuario) && (user.nomeUsuario === data.nomeUsuario)){
        // console.log("IF")
      } else{
        // console.log("Else")
        localStorage.removeItem('authUser');
        window.location.href = "/login";
      }
      })
    .catch(error => console.log(error))

  }

export default router
